import CardWrapper from '@components/UI/CardWrapper';
import { Popper, createFilterOptions } from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ItemSelector } from '@services/requests/companyProfileService/interface';
import { MainData } from '@services/requests/companyProfileService/types/mainData';
import React, { useState } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import {
  CompanyProfileExtendedFormFields,
  CompanyProfileFormFields,
} from '../../CompanyProfileModulesWrapper/types';
import { RepresentativeModuleStyledContainer } from './StyledComponents';

interface RepresentativeModuleProps {
  isEditMode: boolean;
  form: UseFormReturn<
    CompanyProfileFormFields & CompanyProfileExtendedFormFields,
    any,
    CompanyProfileFormFields & CompanyProfileExtendedFormFields
  >;
  mainData: MainData;
}

const filter = createFilterOptions<
  {
    inputValue?: string;
  } & ItemSelector
>();

const CustomPopper = (props: any) => {
  return (
    <Popper
      {...props}
      placement="bottom"
      style={{ width: props.anchorEl.clientWidth, minWidth: 'fit-content' }}
    />
  );
};

function RepresentativeModule({ isEditMode, form, mainData }: RepresentativeModuleProps) {
  const { fields } = mainData.sections.representatives;

  const {
    control,
    formState: { errors },
  } = form;

  const [isJobListOpen, setIsJobListOpen] = useState<boolean>(false);

  const lastOption = fields.job_position.items[fields.job_position.items.length - 1];
  const mainOptionCodes = fields.job_position.items
    .slice(0, fields.job_position.items.length - 1)
    .map((item) => item.code);

  return (
    <RepresentativeModuleStyledContainer>
      <CardWrapper sx={{ padding: '25px 40px' }} className="card">
        <Typography variant={'h3'} className={'module-title'}>
          {mainData.sections.representatives.caption}:
        </Typography>
        <Controller
          control={control}
          name="representativeFullName"
          render={({ field: { onChange, value, ref, onBlur, name } }) => (
            <TextField
              fullWidth
              type="text"
              className="comment-field"
              size={'medium'}
              disabled={!isEditMode}
              label={fields.director.title}
              variant="outlined"
              name={name}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              value={value || ''}
              error={!!errors.representativeFullName}
              InputProps={{ classes: { input: 'browser-default' } }}
            />
          )}
        />
        <div className="other-info-wrapper">
          <Controller
            control={control}
            name="jobTitle"
            render={({ field: { onChange, value, ref, onBlur } }) => (
              //   <Autocomplete
              //     disablePortal
              //     fullWidth
              //     className="job-title"
              //     PopperComponent={CustomPopper}
              //     options={fields.job_position.items ?? []}
              //     disabled={!isEditMode}
              //     selectOnFocus
              //     clearOnBlur
              //     handleHomeEndKeys
              //     freeSolo
              //     onChange={(_, value: any) => {
              //       if (typeof value === 'string') {
              //         onChange(value);
              //         return;
              //       }
              //       if (value?.inputValue) {
              //         onChange(value.inputValue);
              //         return;
              //       }

              //       onChange(value ? value.code : null);
              //     }}
              //     filterOptions={(options, params) => {
              //       const filtered = filter(options, params);

              //       const { inputValue } = params;
              //       const isExisting = options.some((option) => inputValue === option.code);
              //       if (inputValue === '') {
              //         filtered.push({
              //           inputValue: '',
              //           code: '',
              //           title: `или добавьте должность сами`,
              //         });
              //       }
              //       if (inputValue !== '' && !isExisting) {
              //         filtered.push({
              //           code: inputValue,
              //           inputValue,
              //           title: `Добавить должность "${inputValue}"`,
              //         });
              //       }

              //       return filtered;
              //     }}
              //     onBlur={onBlur}
              //     ref={ref}
              //     value={
              //       value
              //         ? (fields.job_position.items ?? []).find((c) => c.code === value) ?? {
              //             inputValue: value,
              //             code: value,
              //             title: `${value}`,
              //           }
              //         : null
              //     }
              //     forcePopupIcon
              //     popupIcon={<KeyboardArrowDownIcon />}
              //     classes={{ input: 'browser-default' }}
              //     renderInput={(params) => (
              //       <TextField
              //         {...params}
              //         label={fields.job_position.title}
              //         error={!!errors.jobTitle}
              //       />
              //     )}
              //     renderOption={(props, option) => {
              //       return (
              //         <MenuItem
              //           {...props}
              //           value={option.code}
              //           key={option.code}
              //           disabled={option.code === ''}
              //           className="a-service-field-selector-option--root"
              //         >
              //           {option.title}
              //         </MenuItem>
              //       );
              //     }}
              //     getOptionLabel={(
              //       option: ItemSelector & {
              //         inputValue?: string;
              //       }
              //     ) => option.title}
              //   />
              <Autocomplete
                disablePortal
                fullWidth
                open={isJobListOpen}
                className="job-title"
                PopperComponent={CustomPopper}
                options={fields.job_position.items ?? []}
                disabled={!isEditMode}
                disableClearable
                filterOptions={(options) => {
                  return options;
                }}
                onChange={(_, value: any) => {
                  setIsJobListOpen(false);

                  onChange(value ? (value.code === 'other' ? '' : value.code) : null);
                }}
                onBlur={() => {
                  setIsJobListOpen(false);
                  onBlur();
                }}
                ref={ref}
                value={
                  value
                    ? (
                        fields.job_position.items.slice(0, fields.job_position.items.length - 1) ??
                        []
                      ).find((c) => {
                        return c.code === value;
                      }) ?? {
                        code: value,
                        title: lastOption.code === value ? '' : `${value}`,
                      }
                    : null
                }
                forcePopupIcon
                popupIcon={<KeyboardArrowDownIcon />}
                classes={{ input: 'browser-default' }}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        readOnly: mainOptionCodes.includes(value),
                        placeholder: !mainOptionCodes.includes(value) ? 'Введите должность' : '',
                      }}
                      label={fields.job_position.title}
                      error={!!errors.jobTitle}
                      onChange={(event) => {
                        onChange(event.target.value);
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (!isEditMode) {
                          return;
                        }
                        setIsJobListOpen((prev) => !prev);
                      }}
                    />
                  );
                }}
                slotProps={{
                  popupIndicator: {
                    onClick: (event) => {
                      event.stopPropagation();
                      if (!isEditMode) {
                        return;
                      }
                      setIsJobListOpen((prev) => !prev);
                    },
                  },
                }}
                renderOption={(props, option) => {
                  return (
                    <MenuItem
                      {...props}
                      value={option.code}
                      key={option.code}
                      className="a-service-field-selector-option--root"
                    >
                      {option.title}
                    </MenuItem>
                  );
                }}
                getOptionLabel={(option: ItemSelector) => option.title}
              />
            )}
          />

          {/* <Controller
            control={control}
            name="jobTitle"
            render={({ field: { onChange, value, ref, onBlur } }) => (
              <Autocomplete
                disablePortal
                fullWidth
                options={jobTitles}
                disabled={!isEditMode}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                // onChange={(_, value) => onChange(value ? value.value : null)}
                onChange={(_, value) => {
                  if (typeof value === 'string') {
                    onChange(value);
                    return;
                  }
                  if (value?.inputValue) {
                    onChange(value.inputValue);
                    return;
                  }

                  onChange(value ? value.value : null);
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  const isExisting = options.some((option) => inputValue === option.value);
                  if (inputValue === '') {
                    filtered.push({
                      id: Math.random(),
                      inputValue: '',
                      value: '',
                      label: `или добавьте должность сами`,
                    });
                  }
                  if (inputValue !== '' && !isExisting) {
                    filtered.push({
                      value: inputValue,
                      inputValue,
                      id: Math.random(),
                      label: `Добавить должность "${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                onBlur={onBlur}
                ref={ref}
                value={
                  value
                    ? jobTitles.find((c) => c.value === value) ?? {
                        id: Math.random(),
                        inputValue: value,
                        value,
                        label: `${value}`,
                      }
                    : null
                }
                forcePopupIcon
                popupIcon={<KeyboardArrowDownIcon />}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={fields.job_position.title}
                    error={!!errors.jobTitle}
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <MenuItem
                      {...props}
                      value={option.value}
                      key={option.id}
                      disabled={option.value === ''}
                      className="a-service-field-selector-option--root"
                    >
                      {option.label}
                    </MenuItem>
                  );
                }}
                getOptionLabel={(option: {
                  value: string;
                  label: string;
                  id: number;
                  inputValue?: string;
                }) => option.label}
              />
            )}
          /> */}
          <Controller
            control={control}
            name="actionReason"
            render={({ field: { onChange, value, ref, onBlur, name } }) => (
              <TextField
                fullWidth
                type="text"
                className="comment-field"
                size={'medium'}
                disabled={!isEditMode}
                label={fields.basis.title}
                variant="outlined"
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                ref={ref}
                value={value || ''}
                error={!!errors.actionReason}
                InputProps={{ classes: { input: 'browser-default' } }}
              />
            )}
          />
        </div>
      </CardWrapper>
    </RepresentativeModuleStyledContainer>
  );
}
export { RepresentativeModule };
